import { render, staticRenderFns } from "./verLeecherosGeocercas.vue?vue&type=template&id=0baa6d94&"
import script from "./verLeecherosGeocercas.vue?vue&type=script&lang=js&"
export * from "./verLeecherosGeocercas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports